import { forEach, isEqual } from 'lodash/fp';
import type { Dispatch } from 'react';

import uncapFpIterator from '../../../../../../../utils/uncap-fp-iterator';

const forEachWithIndex = uncapFpIterator(forEach);

type TilePagination = {
  currentPage: number;
  pageCount: number;
};

const updateTilePagination = (
  element: HTMLElement,
  tilePagination: TilePagination,
  setTilePagination: Dispatch<TilePagination>,
) => {
  const tileContainerRect = element.getBoundingClientRect();

  const tiles = element.children;
  forEachWithIndex((currentTile: HTMLElement, index: number) => {
    const tileRect = currentTile.getBoundingClientRect();

    const isTileInViewport = tileRect.left >= tileContainerRect.left && tileRect.right <= tileContainerRect.right;

    if (isTileInViewport) {
      // @ts-expect-error - Automatic, Please fix when editing this file
      const firstTileRect = tiles[0].getBoundingClientRect();
      // tileWidth does not include the margin between tiles, to accurately calculate the tile width we need to get the margin between tiles, this matters because we need to know how many tiles can fit within the tileContainer to calculate the pageCount otherwise we could see a tile count of `3 of 2` instead of `3 of 3` when the window is resized whilst using css scroll-snap-align.
      const tileMargin = tiles[1] ? Math.abs(firstTileRect.right - tiles[1].getBoundingClientRect().left) : 16;
      const pageCount = Math.ceil(
        tiles.length / Math.floor(tileContainerRect.width / (firstTileRect.width + tileMargin)),
      );
      const newTilePagination = { currentPage: index + 1, pageCount };

      // don't re-render the component if nothing has changed
      if (isEqual(newTilePagination, tilePagination)) {
        return false;
      }

      setTilePagination(newTilePagination);
      return false;
    }

    return true;
  }, tiles);
};

export default updateTilePagination;
